// utils/getStoredUser.ts

export interface StoredUserData {
    [key: string]: any;
}

export const getStoredUserData = (): StoredUserData | null => {
    try {
        const storedAuth = localStorage.getItem("auth-storage");
        if (!storedAuth) return null;

        const authData = JSON.parse(storedAuth);
        return authData?.state?.user?.data ?? null;
    } catch (error) {
        console.error("Error parsing stored auth:", error);
        return null;
    }
};


export const getStoredTransaction = () => {
    try {
        const data = localStorage.getItem("transaction");
        if (!data) return null;

        return JSON.parse(data);
    } catch (error) {
        console.error("Error parsing stored transaction:", error);
        return null;
    }
};
